import CircularProgress from '@mui/material/CircularProgress';
import { Modal } from '@mui/material';
import React, { useEffect, useState } from 'react';

interface DismissHitModalProps {
  open: boolean;
  recordName?: string;
  isProcessing?: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
}

const DismissHitModal: React.FC<DismissHitModalProps> = ({
  open,
  recordName,
  isProcessing,
  onClose,
  onConfirm,
}) => {
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (open) {
      setReason('');
    }
  }, [open]);

  return (
    <Modal open={open} onClose={onClose}>
      <div className='audit-add-modal-cont'>
        <div className='audit-add-modal-cont-head'>
          <div className='audit-add-modal-head-cont'>
            <div className='audit-add-modal-head-cont-icons'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                stroke='#F04438'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              >
                <path d='M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24' />
                <line x1='1' y1='1' x2='23' y2='23' />
              </svg>
            </div>
            <div className='audit-add-modal-head-cont-supporting'>
              <h1>Hide hit</h1>
              <p>
                {recordName
                  ? `Hide “${recordName}” from this entity's screening results. You can optionally add a reason.`
                  : 'Hide this hit from the screening results. You can optionally add a reason.'}
              </p>
            </div>
          </div>
          <div className='audit-add-modal-head-close' onClick={onClose}>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
            >
              <path
                d='M18 6L6 18M6 6L18 18'
                stroke='#85888E'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </div>
        </div>

        <div className='audit-add-modal-cont-body' style={{ marginTop: '20px' }}>
          <div className='audit-add-modal-cont-body-frame'>
            <div
              className='audit-add-modal-cont-body-frame-form-row-input-label'
              style={{ width: '100%' }}
            >
              <label
                htmlFor='dismiss-hit-reason'
                className='audit-add-modal-cont-body-frame-form-row-input-label-text'
              >
                Reason (optional)
              </label>
              <textarea
                id='dismiss-hit-reason'
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder='e.g. False positive — not the same entity'
                className='audit-add-modal-cont-body-frame-form-input'
                style={{
                  width: '100%',
                  height: '96px',
                  paddingTop: '10px',
                  alignItems: 'flex-start',
                  resize: 'vertical',
                }}
                autoFocus
              />
            </div>
          </div>
        </div>

        <div className='audit-modal-cont-footer'>
          <div className='audit-modal-cont-footer-content'>
            <div
              className='audit-modal-cont-footer-content-btn-cancel'
              onClick={onClose}
            >
              <div className='audit-modal-cont-footer-content-btn-text'>
                Cancel
              </div>
            </div>
            <div
              className='audit-modal-cont-footer-content-btn-delete'
              onClick={() => onConfirm(reason.trim())}
            >
              <div
                className='audit-modal-cont-footer-content-btn-text'
                style={{ color: '#FFF' }}
              >
                {isProcessing ? (
                  <>
                    <CircularProgress
                      style={{
                        width: '30px',
                        height: '30px',
                        marginRight: '10px',
                      }}
                      color='error'
                    />{' '}
                    Hiding
                  </>
                ) : (
                  <>Hide hit</>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DismissHitModal;
